module.exports = __webpack_public_path__ + "static/media/210-Mitpatient_ID_21_v2.96018ea9.mp3";